import React from "react";

export default function Hero({ onBookDemo }) {
  return (
    <header className="flex flex-col items-center py-12 md:py-20 px-6 bg-gradient-to-br from-snaptrix-blue-50 via-white to-snaptrix-blue-50 relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-snaptrix-blue-200 rounded-full blur-3xl opacity-20 -mr-32 -mt-32" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-200 rounded-full blur-3xl opacity-20 -ml-48 -mb-48" />
      <div className="relative z-10 flex flex-col items-center">
        <img
          src="/snaptrix-logo.png"
          alt="Snaptrix Logo"
          className="w-40 md:w-48 mb-8 md:mb-10 h-auto drop-shadow-lg"
        />
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-6 max-w-4xl text-snaptrix-gray-700 leading-tight">
          Cricket Clubs. Smarter. Faster. Sharper.
        </h1>
        <p className="text-lg md:text-xl text-center max-w-2xl mb-4 text-snaptrix-gray-600 leading-relaxed">
          Team announcements, match summaries, and top performances — made
          social-ready in seconds with Snaptrix.
        </p>
        <p className="text-base md:text-lg text-center max-w-2xl mb-8 text-snaptrix-gray-500 leading-relaxed">
          Keep match and player sponsors in one place—they're included in every post.
        </p>
        <div className="flex items-center gap-4">
          <button
            onClick={onBookDemo}
            aria-label="Sign up to get started with Snaptrix"
            className="relative bg-gradient-to-r from-snaptrix-blue-600 to-snaptrix-blue-700 hover:from-snaptrix-blue-700 hover:to-snaptrix-blue-800 text-white text-lg px-8 py-4 rounded-xl shadow-lg shadow-snaptrix-blue-200 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-snaptrix-blue-300 focus:outline-none focus:ring-4 focus:ring-snaptrix-blue-200 font-semibold"
          >
            Sign Up
          </button>
          <a
            href="https://app.snaptrix.co.uk/login"
            target="_blank"
            rel="noopener noreferrer"
            className="text-snaptrix-blue-600 hover:text-snaptrix-blue-800 text-lg px-6 py-4 rounded-xl border border-snaptrix-blue-300 hover:border-snaptrix-blue-500 font-semibold transition-all duration-300 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-snaptrix-blue-200"
          >
            Log in
          </a>
        </div>
      </div>
    </header>
  );
}
